module.exports = __webpack_public_path__ + "img/marker-parked.d48cfaf5.svg";